import { appContext } from "../../../../AppContext";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import Helper from "../../../../Common/Helper";
import { Package } from "./DataModels";
import { PagedResponse } from "@iconics/core";
import { ApiConstants } from "../../../../Providers.Api/ApiConstants";
import { JSX } from "react";
import { IRouterProps, withRouting } from "@iconics/components";
import { Button, ButtonBar, Card, DataGrid, GridContainer, GridItem, IGridData, IGridRowsRequest, IGridRowsResponse, LayoutContainer, LayoutContent, RightButtons, TickSymbol } from "@iconics/components";
import { SerendieSymbol } from "@serendie/symbols";

class ListPackages extends IbssPage<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            canCreate: false,
            packagesGrid: { rows: [] },
        };
    }

    public async componentDidMount(): Promise<void>
    {
        const labels = appContext().labels;
        this.pageTitle = labels.Platform_Package_PageTitle;
        this.setState({ canCreate: appContext().localStorageProvider.hasRight('DATAMODEL.Packages.Create') });
    }

    private async handleRowsRequest(request: IGridRowsRequest<IPackage>): Promise<IGridRowsResponse<IPackage>>
    {
        const response = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.packages.get<PagedResponse<Package[]>>({
            select: Package,
            tenancy: appContext().tenantId,
            skipToken: request.skipToken,
            top: request.take,
            orderBy: DataGrid.toODataOrderBy(request.sorter),
        });

        const packages = response.value.map(i => ({
            id: i.Id,
            name: i.Name,
            description: i.Description,
            isEnabled: i.IsEnabled,
            eTag: i["@odata.etag"],
        }));

        return { rows: packages, nextSkipToken: response.skipToken };
    }

    public render(): JSX.Element
    {
        const labels = appContext().labels;

        return (
            <LayoutContainer>
                <LayoutContent>
                    <Card
                        title={labels.Platform_Package_ListTitle}
                        subTitle={labels.Platform_Package_ListSubTitle}
                        icon={<SerendieSymbol name='file' />}
                    >
                        <GridContainer>
                            <GridItem>
                                <ButtonBar>
                                    <RightButtons>
                                        <Button
                                            size='small'
                                            styleType='ghost'
                                            leftIcon={<SerendieSymbol name='plus' />}
                                            onClick={() => this.props.navigate(`/admin/packages/new`)}
                                            disabled={!this.state.canCreate}
                                        >
                                            {labels.Platform_CommonAction_Add}
                                        </Button>
                                    </RightButtons>
                                </ButtonBar>
                            </GridItem>
                            <GridItem>
                                <DataGrid
                                    columns={[
                                        {
                                            columnId: Helper.nameOf<Package>("Name"),
                                            title: labels.Platform_Package_Name,
                                            getCellValue: i => i.name,
                                            columnWidth: 40,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Package>("Description"),
                                            title: labels.Platform_Package_Description,
                                            getCellValue: i => i.description,
                                            columnWidth: 40,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<Package>("IsEnabled"),
                                            title: labels.Platform_Package_IsEnabled,
                                            getCellValue: i => i.isEnabled,
                                            template: i => <TickSymbol value={i.value as boolean} />,
                                            columnWidth: 20,
                                            sortable: true,
                                        },
                                    ]}
                                    data={this.state.packagesGrid}
                                    onChange={i => this.setState({ packagesGrid: i })}
                                    rowId={i => i.id}
                                    onRowsRequest={i => this.handleRowsRequest(i)}
                                    onCellClicked={i => this.props.navigate(`/admin/packages/${i.id}/edit`)}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </LayoutContent>
            </LayoutContainer>
        );
    }
}

export default withRouting(ListPackages)

export interface IProps extends IRouterProps
{
}

export interface IState
{
    canCreate: boolean;
    packagesGrid: IGridData<IPackage>;
}

export interface IPackage
{
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
    eTag: string;
}
